// This file is mainly for reference and the projects listing page
export const projectsData = [
  {
    id: 'spectrum-creatives',
    title: 'Spectrum Creatives',
    shortDescription: 'Supporting neurodivergent creatives through workshops, resources, and curated events.',
    tags: ['Spectrum', 'Open Studio Sessions'],
    imageClass: 'spectrum-creatives',
  },
  {
    id: 'fichua-pazia-unmask',
    title: 'Fichua Pazia (Unmask)',
    shortDescription: 'Safeguarding toolkit and research project ensuring creatives operate in safe, ethical spaces.',
    tags: ['Safeguarding', 'Toolkit', 'Research'],
    imageClass: 'fichua-pazia',
  },
  {
    id: 'mpenzi-mashini',
    title: 'Mpenzi Mashini (Dear Machine)',
    shortDescription: 'One-woman hybrid play integrating AI and human performance. Explores intimacy, authorship, and ethical AI collaboration.',
    tags: ['Hybrid Dramaturgy', 'Performance', 'AI', 'Theatre'],
    imageClass: 'mpenzi-mashini',
  }
];